import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Contact } from './types/contactTypes'

const fetchCategoryContacts = async ({ pageParam = '1', id }: FetchParams): Promise<PaginatedResponse<Contact>> => {
  const url = `/categories/${id}/contacts?page=${pageParam}`
  const { data } = await api.get<PaginatedResponse<Contact>>(url)
  return data
}

export const usePaginateCategoryContacts = (id: string) => {
  return usePaginate<Contact>('category-contacts', fetchCategoryContacts, { id }, { enabled: !!id })
}
